module.exports = __webpack_public_path__ + "img/progress2.b9c7c939.png";